import { Container } from '@mui/material';
import React from 'react';
import MyRequestDetails from './myrequestdetails.page';

const RequestDetailsUserLayout = () => {
  return (
    <Container className='doc-cat-content request-details-page'>
        <MyRequestDetails />
    </Container>
  );
};

export default RequestDetailsUserLayout;